export default __webpack_public_path__ + "static/media/metrica_01.fe1d8afe.png";